import { render, staticRenderFns } from "./DeliveryNotesPopup.vue?vue&type=template&id=7664644b&scoped=true&"
import script from "./DeliveryNotesPopup.vue?vue&type=script&lang=js&"
export * from "./DeliveryNotesPopup.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryNotesPopup.vue?vue&type=style&index=0&id=7664644b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7664644b",
  null
  
)

export default component.exports